// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { Option } from './Select';
import { Id } from '@shared/types/common';

// Build a list of "Options" from a list of objects.  
// "properties" defines which property is used as 'id' and which as 'label' (?).
export const normalize = (
  data: Array<{ [key: string]: any }>,
  properties: { id: string; label: string } = { id: 'id', label: 'name' }
) => {
  return data.map((item): Option => ({ id: item[properties.id], label: item[properties.label] }));
};

export const getFieldOption = (field): Option | Array<Option> | null => {
  return field.extra;
};

// Build a list of "Options" from a dict of labels (?).
export const getOptionsFromLabels = (
  labels: { [key: string]: any },
  properties: { id: string; label: string } = { id: 'id', label: 'label' }
): Array<any> => {
  return Object.keys(labels).map((id) => ({
    [properties.id]: id,
    [properties.label]: labels[id]
  }));
};

// Build an list of "Options" from a list of 'standings'
export const getOptionsFromStandings = (standings: string[]) => {
  return standings.map((item, index) => ({
    id: <Id> (index + 1), // 0 is not a valid 'Id'.  use 1-indexed array.
    label: item,
  }))
};